import React from 'react'
import {StyledBackIcon} from './styled'

const BackIcon = ({fill = '#FFFFFF', width = 34, height = 34, onClick}) => (
  <StyledBackIcon className="back-icon" width={width} height={height} viewBox="0 0 20 20" onClick={onClick}>
    <g id="OL-icon-arrow-down-white" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="Shape" points="0 0 20 0 20 20 0 20" />
      <polygon
        id="Shape"
        fill={fill}
        fillRule="nonzero"
        points="4.645 7 10 12.3433333 15.355 7 17 8.645 10 15.645 3 8.645"
      />
    </g>
  </StyledBackIcon>
)

export default BackIcon
